/**
 * Every Datadog feature flag the client UI reads.
 *
 * This mirrors the `RingbaXFlags` registry in ringba-x (`pkgs/RingbaX.FeatureFlags`): exactly the
 * entries whose `Surface` is `Ui` or `Both`, nothing else. A key that exists here and not there, or
 * there and not here, fails review. The first UI feature behind a flag adds its entry here and in
 * the backend registry in the same PR pair.
 *
 * Each entry is `{ key, type, fallback }`:
 * - `key` is the Datadog flag key, character for character (`rx-[a-z][a-z0-9_-]*`, at most 64).
 *   Every RingbaX key starts with `rx-`, because Portal's flags share the Datadog environments.
 * - `type` is `'boolean'`, `'string'` or `'number'`, and picks the OpenFeature evaluator.
 * - `fallback` is the value every user gets while the provider is not ready, is blocked, or has no
 *   answer for the flag. It is the CURRENT behaviour, so a blocked browser sees today's UI.
 *
 * Read a flag through `this.$featureFlag(FEATURE_FLAG_KEYS.someFlag.key)` or `mapFeatureFlags`
 * (see `src/plugins/featureFlags.js`). Both refuse a key that is not listed here.
 *
 * @type {Readonly<Record<string, { key: string, type: 'boolean' | 'string' | 'number', fallback: boolean | string | number }>>}
 */
export const FEATURE_FLAG_KEYS = Object.freeze({})

/**
 * The entry for a Datadog key, or `undefined` when the key is not in `FEATURE_FLAG_KEYS`.
 */
export function findFeatureFlagDefinition(key) {
  return Object.values(FEATURE_FLAG_KEYS).find(definition => definition.key === key)
}
